import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"

import {
    downLoadTemplateFile,
    exportKeyFile
} from '../../../api/config/modules/KeyFile'
export default {
    name: "KeyFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                driverName: '',
                keyNum: '',
                authorizePower: '',
                FactoryTime: [],
            },
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                    width: "160px"
                }, {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: "160px"
                }, {
                    prop: "keyNum",
                    label: this.$t('DriverManagement.keyNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "authorizePowerStr",
                    label: this.$t('DriverManagement.authorizePower'),
                    align: "center",
                },
                {
                    prop: "makeKeyTime",
                    label: this.$t('DriverManagement.makeKeyTime'),
                    align: "center",
                    width: "160px",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.makeKeyTime))
                    // }
                },
                {
                    prop: "lastUser",
                    label: this.$t('common.lastUser'),
                    align: "center",
                    width: "160px"
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [

                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            typeList: [],
            dialogFormVisible: false,
            formLabelWidth: '112px',
            diaTitle: '',
            btnType: '',
            rules: {
                authorizePower: [{
                    required: true,
                    message: this.$t('DriverManagement.form.inputAuthType'),
                    trigger: 'blur'
                }],
                terminalId: [{
                    required: true,
                    message: this.$t('common.form.terminalId'),
                    trigger: 'blur'
                }],
            },
            form: {
                driverNum: '',
                keyNum: '',
                authorizePower: '',
                terminalId: ''
            },
            disabled: false,
            selected: [],
            id: '',
            name: '',
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAllKey()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllKey()
        },
        getAllKey() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.FactoryTime) {
                if (this.formInline.FactoryTime.length > 0) {
                    startTime = this.formInline.FactoryTime[0]
                    endTime = this.formInline.FactoryTime[1]
                }
            }
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                keyNum: this.formInline.keyNum,
                driverNum: this.formInline.driverNum,
                driverName: this.formInline.driverName,
                authorizePower: this.formInline.authorizePower,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('KeyFile/GET_GETKEY', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllKey()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                driverName: '',
                keyNum: '',
                authorizePower: '',
                FactoryTime: [],
            }
            this.getAllKey()
        },
        addKey() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('DriverManagement.btn.addKey')
            this.btnType = 'add'
            this.disabled = true
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.driverNum = this.selected[0].driverNum
                this.form.terminalId = sessionStorage.getItem("terminalId")
            })
        },
        querySearch(queryString, cb) {
            let restaurants = [];
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                number: queryString,
            }
            this.$store.dispatch('KeyFile/GET_SELECTTERMINALALL', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        if (res.data.data) {
                            for (let i of res.data.data) {
                                i.value = i.terminalId;
                            }
                            restaurants = res.data.data;
                            var results = queryString ? restaurants : restaurants;
                            cb(results);
                            sessionStorage.setItem("terminalId", results[0].terminalId);
                        }
                    }
                }
            }).catch(err => { })
        },
        handleSelect(item) {

        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        companyId: sessionStorage.getItem("companyId"),
                        orgId: this.id,
                        driverNum: this.form.driverNum,
                        keyNum: this.form.keyNum,
                        authorizePower: this.form.authorizePower,
                        terminalId: this.form.terminalId,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('KeyFile/GET_INSERTKEY', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllKey();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }
                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                driverNum: '',
                keyNum: '',
                authorizePower: '',
                terminalId: ''
            }
        },
        closeDia() {
            this.form = {
                driverNum: '',
                keyNum: '',
                authorizePower: '',
                terminalId: ''
            }
            this.dialogFormVisible = false;
        },

        downKey() {
            if (domainName) {
                let startTime = ''
                let endTime = ''
                if (this.formInline.FactoryTime) {
                    if (this.formInline.FactoryTime.length > 0) {
                        startTime = this.formInline.FactoryTime[0]
                        endTime = this.formInline.FactoryTime[1]
                    }
                }
                let companyId = sessionStorage.getItem("companyId")
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportKey?orgId=${this.id}&companyId=${companyId}&driverName=${this.formInline.driverName}&driverNum=${this.formInline.driverNum}&authorizePower=${this.formInline.authorizePower}&keyNum=${this.formInline.keyNum}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportKey?orgId=${this.id}&companyId=${companyId}&driverName=${this.formInline.driverName}&driverNum=${this.formInline.driverNum}&authorizePower=${this.formInline.authorizePower}&keyNum=${this.formInline.keyNum}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url

                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllKey();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}